module.exports = "/_next/static/images/book-3534a6fe90ce6742c06b1734e52d1ddb.png";